

  <ngx-charts-pie-chart style="padding:1px"
                        [view]="view | async"
                        [scheme]="options?.colourScheme ?? scheme"
                        [results]="_results | async"
                        [gradient]="gradient"
                        [legend]="legend"
                        [legendPosition]="legendPosition"
                        [legendTitle]="legendTitle"
                        [labels]="labels"
                        [doughnut]="true"
                        [trimLabels]="false"
                        (select)="onSelect($event, null)"
                        (activate)="onActivate($event)"
                        (deactivate)="onDeactivate($event)">
    <ng-template *ngIf="eveTooltipTemplate != null" #tooltipTemplate let-model="model">
      <ng-container *ngTemplateOutlet="eveTooltipTemplate;context:{model}"></ng-container>
    </ng-template>
  </ngx-charts-pie-chart>

  <div [innerHTML]="legendStyles | async"></div>






